import PageHeading from 'elements/PageHeading';
import Pattern from 'elements/Pattern';

export default function ContentPageLayout({ title, subTitle, children, className = '', contentClassName = '' }) {
    return (
        <main className={`relative flex min-h-screen w-full flex-col items-center overflow-hidden gradient-green px-site py-site ${className}`}>
            <Pattern className="pointer-events-none opacity-45" />

            <div className="relative z-10 flex w-full max-w-boxed flex-col gap-8 lg:gap-10">
                <PageHeading
                    title={title}
                    subTitle={subTitle}
                    align="left"
                    mobileAlign="center"
                />

                <article className={`content-page-card mx-auto w-full max-w-5xl rounded-3xl border border-white/70 bg-white p-5 text-neutral-700 shadow-2xl sm:p-8 lg:p-12 ${contentClassName}`}>
                    {children}
                </article>
            </div>
        </main>
    );
}
